import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./SettingProfile.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import LogItem from "../../comm/global/components/LogItem";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ImageLoader from "../../comm/global/components/ImageLoader";
import { borderRadius } from "polished";
import { GameContext } from "../../GameContext";
const SettingProfile = ({ setModalType, arg, addModalType }) => {
    const { userData } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const [tempImg,set_tempImg]=useState("./photo/photo1.jpg");
    useEffect(() => {
        setInProp(true);
        
        document.title = "個人檔案";
    }, [])

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "SettingProfile"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        <YStyled.Col align="center" gap=".5rem" style={{ marginTop: "1rem"}}>
                            <ImageLoader variant={"circular"} width={"100%"} height={"100%"} style={{width:"30%",borderRadius:"50%"}} src={tempImg} />
                            <YStyled.Span color="#3149CE" size={15} style={{cursor:"pointer"}} onClick={e=>{
                               /*  addModalType({cls:"SetProfileIcon",arg:{photo:tempImg,cb:imgData=>{
                                    set_tempImg(imgData)
                                }}}) */
                            }}>設定頭像</YStyled.Span>
                        </YStyled.Col>
                        <div className={styleUi.view}>
                            <YStyled.Label style={{ width: "100%", marginTop: "2rem", paddingRight: "0px" }}>
                                <YStyled.Col>
                                    <YStyled.Row style={{ paddingRight: "1rem" }} onClick={e=>{
                                       // addModalType({cls:"EditProfile1",arg:{type:"name",value:"Eugene Ding"}})
                                        }}>
                                        <YStyled.Span fontWeight={400} size={17} style={{ width: "25%" }}>名稱</YStyled.Span>
                                        <YStyled.Span fontWeight={400} size={17} style={{ width: "50%" }}>{userData.users_name}</YStyled.Span>
                                        <ArrowForwardIosIcon style={{ fontSize: "1rem", color: "#3C3C4355" }} />
                                    </YStyled.Row>
                                    <YStyled.Hr style={{ margin: ".8rem 0" }} />
                                    <YStyled.Row style={{ paddingRight: "1rem" }} onClick={e=>{
                                       // addModalType({cls:"EditProfile1",arg:{type:"ID",value:"eugene_world"}})
                                        }}>
                                        <YStyled.Span fontWeight={400} size={17} style={{ width: "25%" }}>ID</YStyled.Span>
                                        <YStyled.Span fontWeight={400} size={17} style={{ width: "50%" }}>{userData.users_username}</YStyled.Span>
                                        <ArrowForwardIosIcon style={{ fontSize: "1rem", color: "#3C3C4355" }} />
                                    </YStyled.Row>
                                    <YStyled.Hr style={{ margin: ".8rem 0" }} />
                                    <YStyled.Row style={{ paddingRight: "1rem" }} onClick={e=>{
                                       // addModalType({cls:"EditProfile1",arg:{type:"mail",value:"abcde123@gmail.com"}})
                                        }}>
                                        <YStyled.Span fontWeight={400} size={17} style={{ width: "25%" }}>電子信箱</YStyled.Span>
                                        <YStyled.Span fontWeight={400} size={17} style={{ width: "50%" }}>{userData.users_email}</YStyled.Span>
                                        <ArrowForwardIosIcon style={{ fontSize: "1rem", color: "#3C3C4355" }} />
                                    </YStyled.Row>
                                    <YStyled.Hr style={{ margin: ".8rem 0" }} />
                                    <YStyled.Row style={{ paddingRight: "1rem" }}  onClick={e=>{
                                            //addModalType({cls:"EditPassword",arg:{}})
                                        }}>
                                        <YStyled.Span fontWeight={400} size={17} style={{ width: "25%" }}>密碼</YStyled.Span>
                                        <YStyled.Row style={{ width: "auto", gap: ".5rem" }}>
                                            <YStyled.Span fontWeight={400} size={17} style={{ color: "#3C3C43dd" }}>變更</YStyled.Span>
                                            <ArrowForwardIosIcon style={{ fontSize: "1rem", color: "#3C3C4355" }} />
                                        </YStyled.Row>
                                    </YStyled.Row>
                                </YStyled.Col>
                            </YStyled.Label>

                            <YStyled.Span color="#3C3C43" fontWeight={400} size={13} style={{alignSelf:"flex-start",paddingLeft:"1rem",marginTop:"2rem"}} >帳號連結</YStyled.Span>
                            <YStyled.Label style={{ width: "100%", marginTop: ".5rem", paddingRight: "0px" }}>
                                <YStyled.Col>
                                    <YStyled.Row style={{ paddingRight: "1rem" }} >
                                        <YStyled.Span fontWeight={400} size={17} >Facebook</YStyled.Span>
                                        <YStyled.Span color="#3149CE" fontWeight={400} size={17} >綁定</YStyled.Span>
                                    </YStyled.Row>
                                    <YStyled.Hr style={{ margin: ".8rem 0" }} />
                                    <YStyled.Row style={{ paddingRight: "1rem" }} >
                                        <YStyled.Span fontWeight={400} size={17} >Instagram</YStyled.Span>
                                        <YStyled.Span color="#3149CE" fontWeight={400} size={17} >綁定</YStyled.Span>
                                    </YStyled.Row>
                                    <YStyled.Hr style={{ margin: ".8rem 0" }} />
                                    <YStyled.Row style={{ paddingRight: "1rem" }} >
                                        <YStyled.Span fontWeight={400} size={17} >LINE</YStyled.Span>
                                        <YStyled.Span color="#3149CE" fontWeight={400} size={17} >已綁定</YStyled.Span>
                                    </YStyled.Row>
                                </YStyled.Col>
                            </YStyled.Label>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(SettingProfile);